import { Component, OnInit, Inject, HostListener } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { EvalReasonArchiveHelper, EvaluationVehicle } from "@app-model/evaluation";

@Component({
  selector: "app-dialog-reject-fast-quote-bid",
  templateUrl: "./dialog-reject-fast-quote-bid.component.html",
  styleUrls: ["./dialog-reject-fast-quote-bid.component.scss"],
})
export class DialogRejectFastQuoteBidComponent implements OnInit {
  vehicle: EvaluationVehicle;

  title = "Qual o motivo da recusa?";
  message = "Proposta recusada com sucesso";
  messageError =
    "Não foi possível recusar essa proposta no momento. Tente novamente mais tarde";

  allReasons = [
    { name: 'Cliente desistiu', value: 'CUSTOMER_GAVE_UP' },
    { name: 'Valor não aprovado', value: 'PRICE_TOO_LOW' },
    { name: 'Fechado para outra revenda', value: 'OTHER_DEALER' }
  ];
  
  reason: string;

  constructor(
    private dialogRef: MatDialogRef<DialogRejectFastQuoteBidComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      vehicle: EvaluationVehicle;
    }
  ) {
    this.vehicle = data.vehicle;
  }

  ngOnInit() {
    this.dialogRef.disableClose = false;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  @HostListener("window:keyup.esc")
  onKeyUp() {
      this.onNoClick();
  }

  onClickConfirm() {
    this.dialogRef.close(this.reason);
  }

  updateStatusScreen(status: boolean) {
    this.dialogRef.disableClose = status;
  }
}
